(function (angular) {
    'use strict';

    angular.module('app')
        .controller('forumThreadController', forumThread);

    forumThread.$inject = [
        'threadPayload',
    ];

    function forumThread(
        threadPayload
    ) {
        var vm = this;

        vm.thread = threadPayload;
    }

}(angular));